import { RootState } from "../../../../store";
import { commitmentsSliceSelector } from "../../common/commitmentsSliceSelector";
import { CommitmentsRecommendationsFilters } from "../../../utils/types/types";

export const commitmentsRecommendationsFiltersSelector = (
  state: RootState,
): CommitmentsRecommendationsFilters => {
  return commitmentsSliceSelector(state).recommendationsFilters;
};
